'use strict';

/*

Error Types Required:

1 - TRY_AGAIN_LATER, https: //zpl.io/25w7kAo
2 - NOT_SUPPORTED, https: //zpl.io/VD4ekWw
3 - NO_ACCOUNTS, https: //zpl.io/29Prkje
4 - UNEXPECTED_ERROR, https: //zpl.io/Vx1EGwx
5 - DLT_FALLBACK_ERROR, https://app.abstract.com/projects/ad846690-94e0-11e7-b686-1fedb049e680/branches/0dad0db8-7e3d-4764-99b3-e417305872af/commits/d0e598edb37cfa53ac27a396bd2927317e34214c/files/ECA8D842-BA25-441D-B05D-3D8661329D12/layers/8EFF581C-7855-478C-9330-23AD815BD014?collectionId=6a9239ed-be87-464b-b2d4-6c91798f8103&collectionLayerId=bdbf7227-1e76-4917-8d2c-7e71ef8dfbb2&mode=build&selected=root-4A853B0E-1704-41A7-81A2-17937ED179B8

To use:

$('.selector').mogo().create(
     'PlaidBankError', {
       errorType: 'TRY_AGAIN_LATER'
     });

if no errorType is passed, the component will not be visible

view source: /views/pages/member/components/plaid-bank-error
style source: /stylesheets/components/_plaid-bank-error
content source: /content/component/plaid-bank-error.json
*/

function PlaidBankError() {
  this.id = null;
  this.node = null;
  this.extends = [_AnalyticsData];
  this.analytics = new Analytics();

  this._DEBUG = false;
  if (this._DEBUG) this.pageName = '[PlaidBankError]';

  // Params
  this.errorType = null;
  this.callback = function () {};
  this._$preloaderContainer = $('<div>', { class: 'mogo-component-plaid-bank-error--loader' });
  this._$preLoader = $('<span>', { class: 'progress-infinite dark' });

  this._viewPath = '/member/components/plaid-bank-error';
  this._onViewComplete = $.Deferred();

  this.init = function () {
    if (this._DEBUG) console.log(this.pageName + ' init() called');

    this._$node = $(this.node);

    this._$node.css('display', 'block').html(this._$preloaderContainer.append(this._$preLoader));

    $.when(this._onViewComplete).then(this._displayViewType.bind(this));

    // Load library
    this._$node.load(this._viewPath, this._onViewLoad.bind(this));
  };

  this._onViewLoad = function (data, response) {
    var pugHtml = data;

    // Append html in to the node
    this._$node.html(pugHtml);
    this._$preLoader.remove();
    this._onViewComplete.resolve();
  };

  /*
    _displayViewType: Remove progress loader when done &&
    removes hide from from body content the correct type &&
    [data-mogo-ui] is display: none by default
  */

  this._displayViewType = function () {
    var errorNode = this._getErrorNodeReference(this.errorType);
    if (errorNode) {
      this._$node.find(errorNode).removeClass('hide');
    }
    this.callback({ errorType: this.errorType });
  };

  this._getErrorNodeReference = function (errorType) {
    switch (errorType) {
      case 'TRY_AGAIN_LATER':
        return '.js--plaid-error-type-hold';
      case 'NOT_SUPPORTED':
        return '.js--plaid-error-type-change';
      case 'NO_ACCOUNTS':
        return '.js--plaid-error-type-unfound';
      case 'UNEXPECTED_ERROR':
        return '.js--plaid-error-type-error';
      case 'DLT_FALLBACK_ERROR':
        return '.js--plaid-error-type-dlt-fallback';
      default:
        return false;
    }
  };

  this.initAllReady = function () {};

  this.destroy = function () {};
}